import axios from 'axios'
import { getCall, postCall, putCall, genericPostCall } from '../../utils/apiCalls'
import { BaseCoreURL } from '../../config';

import {
  OPERATOR_ROUTES_LIST,
  ROUTE_SERVICES,
  CLEAR_DRIVER_DETAILS
} from './actionTypes'

import {
  GET_ROUTE_SERVICES,
  PHONETIC_CITY_SEARCH,
  UPDATE_DRIVER_DETAILS
} from '../../config/urls';


export const fetchServices = (query) => dispatch => {
  getCall(GET_ROUTE_SERVICES, query)
    .then(res => {
      let isError = (res && res.response && res.response.status >= 400) || !res.data || !res.data.body || !res.data.body.length;
      if(isError) {
        alert("No Services found for selected source and destination.");
        // clear the previous results
        dispatch({
          type: ROUTE_SERVICES,
          payload: { data: {} },
        })
        return;
      }
      dispatch({
        type: ROUTE_SERVICES,
        payload: { data: res.data || [] },
      })
    })
}

export const fetchCities = (searchString, fieldType) => dispatch => {
  const url = BaseCoreURL + PHONETIC_CITY_SEARCH + searchString + '?is_phonetic=true';
  genericGetCall(url)
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: OPERATOR_ROUTES_LIST,
          payload: { data: res.data || [], fieldType },
        })
      } else {
        alert('Error, Please try again.');
      }
    })
}

export const updateDriverDetails = (data, callback) => dispatch => {
  // data is an array, create multiple calls by looping over array and waiting for those calls to finish using promise.all
  const headers = {
    "bus-ek": "operator_dashboard",
  };
  let tripDriverDetailsAPIPromises = [];
  let url = UPDATE_DRIVER_DETAILS;
  data.forEach( tripDriverDetails => {
    tripDriverDetailsAPIPromises.push(postCall(url, tripDriverDetails, false, headers));
  })
  Promise
   .all(tripDriverDetailsAPIPromises)
   .then(res => {
      if (res.length && res[0].status === 200) {
        alert('Driver Details Updated Successfully.')
        callback();
      } else {
        alert(((res.length === 0 || res[0].response || {}).data || {}).message || 'Error Occurred, please try later');
      }
    })
 }

 export const clearDriverDetails = () => dispatch => {
   dispatch({
     type: CLEAR_DRIVER_DETAILS
   })
 }

const genericGetCall = (url, query = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  return axios
    .get(url, { headers, params: query })
    .then(response => response)
    .catch(error => {
      return error
    })
}
